import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "xiugaimima"
};
const _hoisted_2 = {
  class: "panel",
  style: {
    "width": "500px"
  }
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, [/*#__PURE__*/_createElementVNode("h2", null, "修改密码")], -1);

const _hoisted_4 = {
  class: "panel-body"
};
const _hoisted_5 = {
  class: "myform"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("当前密码");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("新密码");

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "必须包含大小写字母和数字组合，8-20位", -1);

const _hoisted_9 = /*#__PURE__*/_createTextVNode("重复新密码");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("确认修改");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 10
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 14
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "top_up_value",
        modelValue: $data.pwd.old,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pwd.old = $event),
        size: "small",
        clearable: "",
        "show-password": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 10
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 14
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "top_up_value",
        modelValue: $data.pwd.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.pwd.value = $event),
        size: "small",
        clearable: "",
        "show-password": ""
      }, null, 8, ["modelValue"]), _hoisted_8]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 10
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 14
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        ref: "top_up_value",
        modelValue: $data.pwd.confirm,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.pwd.confirm = $event),
        size: "small",
        clearable: "",
        "show-password": ""
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })]), _createVNode(_component_el_button, {
    style: {
      "margin-top": "10px"
    },
    type: "warning",
    onClick: $options.sub
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["onClick"])])])]);
}